// Decides what the search value store should become for a raw input value,
// enforcing the minimum-length trigger. Below the threshold the search must not
// fire, so the value is cleared (empty string) rather than left stale; at or
// above it, the raw value is used.
export const resolveSearchValue = (rawValue: string | undefined, minSearchLength = 0): string => {
	const value = rawValue ?? '';

	if (value.trim().length < minSearchLength) {
		return '';
	}

	return value;
};
